import AuthState from '@/contexts/auth/AuthState';

export default interface AuthAction {
  type: ActionType;
  payload?: AuthState;
}

export enum ActionType {
  login = 'login',
  logout = 'logout',
  cookieLogin = 'cookieLogin',
  error = 'error',
}
